import { Backdrop, Button, CircularProgress, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import { getOrganizationWithID } from '../../../redux/actions/Organizations'

import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'
import InstancesTableOrg from './TableNavigable/TableNavigable'
import useStyles from './useStyles'
import { getOrganizationAccess } from '../../../redux/actions/eAuthz'
import styled from '@emotion/styled'
import InfoIcon from '@mui/icons-material/Info'
import logoME from '../../../images/me.png'
import { BasicEnabledME } from '../../../components/Modals/Instances/Modules/Organization/BasicEnabledME'
import CancelIcon from '@mui/icons-material/Cancel'
// import ManageSearchIcon from '@mui/icons-material/ManageSearch'

const InputButton = styled(Button)(() => ({
  background: '#00a78f',
  '&:hover': {
    background: '#0CABA8'
  },
  borderRadius: '5rem',
  height: 40,
  fontSize: '1rem',
  color: '#fff'
}))

export default function InstancesOrg () {
  const classes = useStyles()
  const [rows, setRows] = useState([])
  const [organization, setOrganization] = useState(null)
  const [loading, setLoading] = useState(false)
  const [notFound, setNotFound] = useState(false)

  const dispatch = useDispatch()
  const { id } = useParams()

  // get organization with ID
  const getOrganization = async () => {
    const getOrg = await dispatch(getOrganizationWithID(id))
    if (getOrg) {
      setOrganization(getOrg)
    }
  }

  const getOrganizationAccessStatus = async () => {
    const instances = await dispatch(getOrganizationAccess(id))
    if (instances && instances.applicationInstances) {
      setRows(instances.applicationInstances)
    }
    if (instances === 'NotFound') setNotFound(true)
  }

  const [openModal, setopenModal] = useState(false)

  const handleOpen = () => {
    setopenModal(true)
  }

  const handleClose = () => {
    setopenModal(false)
  }

  useEffect(async () => {
    setLoading(true)
    await getOrganization()
    await getOrganizationAccessStatus()
    setLoading(false)
  }, [id])

  if (loading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    )
  }
  return (
    <div className={classes.root}>
      <BreadcrumbsComponent name={organization?.organizationName} />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Instancias de aplicación asociadas
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon style={{ color: '#00a78f', marginLeft: 10 }} />
        <Typography className={classes.subtitle}>
          La siguiente lista muestra las instancias de las aplicaciones
          asociadas a la organización{' '}
          {organization ? organization.organizationName : ''}.
        </Typography>
      </div>
      {/* <div
        className={classes.buttonVerifyStateMEApp}
        onClick={() => (window.location.href = `/organizations/${id}/statusME`)}
      >
        <ManageSearchIcon style={{ color: '#008471' }} />
        <Typography className={classes.subtitle}>
          Verificar el estado de inicialización Mi Estudio versión básico
        </Typography>
      </div> */}
      <div className={classes.boxTable}>
        {notFound
          ? (
          <div
            style={{
              marginTop: '2rem',
              fontFamily: 'Roboto',
              color: '#2C3532',
              height: '30vh'
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '1rem',
                justifyContent: 'center',
                height: '15%'
              }}
            >
              <CancelIcon sx={{ fontSize: '2rem', color: '#AD0707' }} />
              <Typography
                  className={classes.message}
              >
                La organización no tiene configurada ninguna instancia de la
                aplicación Mi Estudio
              </Typography>
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '0.5rem',
                height: '65%'
              }}
            >
              <div>
                  <Typography
                 className={classes.messageQuestion}
                >
                  ¿Desea habilitar Mi Estudio Versión Básico?
                </Typography>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <div>
                    <img
                      src={logoME}
                      style={{ width: 40, height: 40, paddingTop: 5 }}
                    ></img>
                  </div>
                  <div style={{ paddingLeft: 20 }}>
                    <InputButton onClick={handleOpen}>
                      Habilitar Mi Estudio
                    </InputButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
            )
          : (
          <InstancesTableOrg rows={rows} setLoading={setLoading} />
            )}
      </div>
      <BasicEnabledME
        openModal={openModal}
        handleClose={handleClose}
        organization={organization}
      />
    </div>
  )
}
